import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { resolveCoords } from '../../maps/ilceKoordinatlari';
import { migrateLegacyIhale } from './calc';
import { TemelBilgiler, SorumlularLokasyon, FirmaDurum, FinansalBilgiler, SureKabul } from './IhaleDetailSections';

// Sihirbazın 5 adımıyla birebir aynı bölümleri gösterir
export function IhaleDetailDialog({ open, onOpenChange, ihale: raw, users = [], displayMoney, onEdit, onExportPDF }) {
  if (!raw) return null;
  const ihale = migrateLegacyIhale(raw);
  const konum = resolveCoords(ihale.enlem, ihale.boylam, ihale.ilcesi, ihale.id);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-gray-900 border-gray-800 text-white max-w-5xl max-h-[85vh] overflow-y-auto" data-testid="ihale-detail-dialog">
        <DialogHeader>
          <DialogTitle className="text-blue-400" data-testid="ihale-detail-title">İhale Detayları: {ihale.ihale_no}</DialogTitle>
          <DialogDescription className="text-gray-400" data-testid="ihale-detail-isin-adi">{ihale.isin_adi}</DialogDescription>
        </DialogHeader>
        <div className="space-y-5 py-2">
          <TemelBilgiler ihale={ihale} users={users} displayMoney={displayMoney} />
          <SorumlularLokasyon ihale={ihale} users={users} displayMoney={displayMoney} konum={konum} />
          <FirmaDurum ihale={ihale} users={users} displayMoney={displayMoney} />
          <FinansalBilgiler ihale={ihale} displayMoney={displayMoney} />
          <SureKabul ihale={ihale} users={users} displayMoney={displayMoney} />
        </div>
        <DialogFooter>
          <Button onClick={() => { onOpenChange(false); onEdit(raw); }} className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="detail-edit-btn">
            Düzenle
          </Button>
          <Button onClick={() => onExportPDF(raw)} className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="detail-pdf-btn">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            PDF İndir
          </Button>
          <Button onClick={() => onOpenChange(false)} className="bg-gray-800 text-white hover:bg-gray-700" data-testid="detail-close-btn">
            Kapat
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
